<app-confirm-dialog></app-confirm-dialog>
<div *ngIf="this.authWebService.authenticated">
    <div class="container-my">
        <img src="/assets/banner4.png" alt="iCBMS" style="width:100%;">

        <div class="text-block ">

            <div class="wrapper">
                <nav id="sidebar">

                    <!--<div class="sidebar-header">-->
                    <form class="form-inline my-2 my-lg-0">
                        <ul class="list-unstyled components">
                            <li>
                                <a *ngIf="this.authWebService.authenticated" href="#userSubMenu" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle spacer-x" role="button" aria-haspopup="true">
                  {{this.authWebService.userData?.User?.FirstName}} {{this.authWebService.userData?.User?.LastName}} <span class="caret"></span>
                </a>
                                <ul *ngIf="this.authWebService.authenticated" class="collapse list-unstyled" id="userSubMenu">
                                    <li>
                                        <a class="inner menu-shd" [routerLink]="['/ammenduser']">
                      Profile
                    </a>
                                    </li>
                                    <li>
                                        <!-- <a class="inner menu-shd" [routerLink]="['/reset']">
                      Reset Password
                    </a> -->
                                    </li>
                                    <li>
                                        <a class="inner menu-shd" (click)="this.authWebService.logout()" style="cursor: pointer;">
                      Logout
                    </a>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                        <ul class="list-unstyled components">
                            <img src="/assets/profile-icon.PNG" alt="iCBMS">
                        </ul>
                    </form>



                    <!--</div>-->

                </nav>

            </div>

        </div>

    </div>
<mat-toolbar *ngIf="paygateEnabled == true" color="primary" > 
    <div style="justify-content: center;display: flex; align-items: center;text-align: center; font-size: large;">
    <b>>>> GREAT NEWS!! <<< </b> &nbsp; We Accept Online Payments: Go To<b>  &nbsp; &#8594; My Accounts &#8594; View Accounts</b>, select the account you want to deposit money into. Then Select the “Fund Account” Option.
    </div>
  </mat-toolbar>
  <mat-toolbar *ngIf="paygateEnabled == false" style="background-color:black;" >
    <div style="justify-content: center;display: flex; align-items: center;text-align: center; font-size: large;">
      <b>>>> NOTICE: <<< </b> &nbsp;  Payment Gateway is currently offline due to maintenance.. 
    </div>
  </mat-toolbar>
</div>
<br>





<div *ngIf="!this.authWebService.authenticated">

    <router-outlet></router-outlet>
</div>
<div class='container-fluid' *ngIf="this.authWebService.authenticated">
    <table style="width:100%;margin:0;padding:0;" [ngClass]="{'table-responsive':enableClass}">
        <tr style="margin-top:0px!important;">
            <td class="posiL">
                <side-menu></side-menu>
            </td>
            <td class="posiR">
                <div class="p-3 mb-2 bg-danger text-white" *ngIf="( this.signalrService.sub | async)">Your session will be terminated in {{ this.signalrService.sub | async }} seconds</div>

                <router-outlet></router-outlet>
            </td>
        </tr>
    </table>
</div>

<footer style="margin:0px;padding:0px;" *ngIf="this.authWebService.authenticated">
    <div class="row" style="margin:0px;padding:0px;">

        <div class="col-12" style="margin:0px;padding:0px;">
            <app-footer-statment *ngIf="utility.showStatementFooter$ | async"></app-footer-statment>
            <footer-btn [ctrlData]="ctrlData" *ngIf="!utility.isView" class=""></footer-btn>
        </div>
        <div class="col-12" style="margin:0px;padding:0px;">
            <div class="footer" style="text-align:center; background-color: #4D4D4F; margin:0px;padding:0px;">
                <span>{{ftitle}}</span>
            </div>
        </div>
    </div>
</footer>

<div bsModal #childModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name">
    <div class="modal-dialog modal-md">
        <div class="modal-content bgd-c" style="border:none!important;">
            <div class="modal-body" style="border:none!important;">
                <p class="h5" style="color:white!important;">You have been idle!</p>
                <small class="extra-clr ft-c"> {{idleState}}</small><br />
                <small class="text-small" style="color:white!important;font-size:10px!important">You may extend your session.</small>
                <div style="border:none!important;height:20px!important;margin-top:5px!important;">
                    <button type="button" class="btn btn-danger btn-sm pull-right" style="margin-right:4px!important;width:60px!important;" (click)="logout()">Leave</button>
                    <button type="button" class="btn btn-primary btn-sm pull-right" style="margin-right:4px!important;padding-right:4px!important;width:60px!important;" (click)="stay()">Stay</button>
                </div>
            </div>
        </div>
    </div>
</div>

<script src="https://apis.google.com/js/platform.js" async defer></script>
